import React from 'react';
import loadable from '@loadable/component';

const Redeem = loadable(() => import('./Redeem'));

export const RedeemRoute = () => ({
  path: '/redeem',

  indexRoute: {
    component: props => <Redeem {...props} />,
  },

  childRoutes: [
    {
      path: 'new',
      onEnter: (nextState, replaceState) => replaceState('/redeem'),
    },
  ],
});
